<script>
export default {
  mounted() {
    if (!window.sizingAppConfig) return;

    const styles = window.sizingAppConfig.styles;

    for (let key in styles) {
      switch (key) {
        case 'primaryColor':
          this.$el.style.setProperty('--primary-color', styles[key]);
          break;
        case 'borderRadius':
          this.$el.style.setProperty('--border-radius', styles[key]);
          break;
        case 'primaryButtonTextColor':
          this.$el.style.setProperty('--primary-button-text-color', styles[key]);
          break;
      }
    }
  },
};
</script>
